// Prismic stores every "Web" link as an absolute URL. Editors use that to point
// at headings on our own pages (https://www.parking4less.com/foo#section) or
// type a bare "#section", which Prismic saves as "https://#section". Both end
// up as a full browser navigation. This turns them back into something Gatsby
// can handle in-page.

const siteHosts = new Set(['parking4less.com', 'www.parking4less.com'])
try {
  if (process.env.GATSBY_COMPANY_URL) siteHosts.add(new URL(process.env.GATSBY_COMPANY_URL).host.toLowerCase())
} catch (e) {
  // ignore a malformed env value
}

// Gatsby pages on this site all end in a slash. Netlify redirects the
// slash-less form, which would be a reload, so add it here. Leave file-like
// paths (sitemap.xml, something.pdf) alone.
const withTrailingSlash = (pathname) => {
  if (!pathname || pathname === '/') return '/'
  const last = pathname.split('/').pop()
  if (last.includes('.')) return pathname
  return pathname.endsWith('/') ? pathname : `${pathname}/`
}

/**
 * Returns an in-site href for a link that points at this site, or null when
 * the link really is external.
 *
 *   #section                               -> #section
 *   https://#section                       -> #section
 *   https://www.parking4less.com/foo#bar   -> /foo/#bar
 *   https://parking4less.com/foo/?a=1      -> /foo/?a=1
 *   https://www.google.com/                -> null
 */
export const toInternalHref = (href) => {
  if (!href || typeof href !== 'string') return null
  const trimmed = href.trim()

  if (trimmed.startsWith('#')) return trimmed

  const bareHash = trimmed.match(/^https?:\/\/#(.*)$/i)
  if (bareHash) return `#${bareHash[1]}`

  let url
  try {
    url = new URL(trimmed)
  } catch (e) {
    return null
  }
  if (url.protocol !== 'http:' && url.protocol !== 'https:') return null
  if (!siteHosts.has(url.host.toLowerCase())) return null

  return `${withTrailingSlash(url.pathname)}${url.search}${url.hash}`
}
